<template>
  <v-container fluid>
    <div id="app ">
      <v-row>
        <v-col cols="11">
          <Breadcrumb
            class="row justify-content-center mt-4"
            :crumbs="crumbs"
            @selected="selected"
          />
        </v-col>
        <v-col cols="1" v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </v-col>
      </v-row>
    </div>
    <v-data-table
      ref="theDataTable"
      :headers="headersData"
      :items="operatorsData"
      :search="search"
      :items-per-page="15"
      @pagination="pagination = $event"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="50"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class=""
                    outlined
                    fab
                    small
                    color="#0C479D"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>icon-download</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-divider></v-divider>

                  <v-list>
                    <v-list-item>
                      <v-list-item-action>
                        <vue-json-to-csv
                          :json-data="dataDownload"
                          :csv-title="'Alerts Data'"
                        >
                          <v-btn color="indigo" dark style="">
                            CSV
                          </v-btn>
                        </vue-json-to-csv>
                      </v-list-item-action>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-action>
                        <v-btn @click="createPDF" color="indigo" dark
                          >PDF
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
              <v-btn
                class="mr-2"
                outlined
                small
                fab
                color="#0C479D"
                v-bind="attrs"
                v-on="on"
                @click="addDoc()"
              >
                <v-icon>icon-add</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-autocomplete
                        :items="machineItems"
                        :disabled="disablemachine"
                        v-model="editedItem.machine_id"
                        prepend-icon="icon-dpimm"
                        @change="assigndevice($event)"
                        label="Select Machines(s)*"
                        item-text="machine_name"
                        item-value="id"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-autocomplete
                        :items="devices"
                        :disabled="disableDevice"
                        v-model="editedItem.device_id"
                        @change="getdeviceid($event)"
                        prepend-icon="icon-cog-single"
                        label="Devices"
                        item-text="device_name"
                        item-value="id"
                      />
                    </v-col>
                    <!-- <v-col cols="12" sm="6" md="4">
                          <v-autocomplete
                            :items="parameters"
                            :disabled="disableOperationalParameter"
                            v-model="editedItem.parameter_id"
                            prepend-icon="icon-cog-single"
                            label="Operational Parameter*"
                            item-text="parameter_name"
                            item-value="parameter_id"
                          />
                        </v-col> -->
                    <!-- <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.email"
                          prepend-icon="icon-email"
                          label="eMail*"
                        ></v-text-field>
                      </v-col> -->
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        label="Users*"
                        :items="userItems"
                        item
                        v-model="editedItem.user_id"
                        prepend-icon="icon-user"
                        item-text="user_name"
                        item-value="user_id"
                        required
                        multiple
                        :rules="selectedItemsRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.insight_name"
                        prepend-icon="icon-email"
                        label="insight_name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.insight_type"
                        prepend-icon="icon-email"
                        label="insight_type"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <label class="radiolabel">Enable</label>
                      <v-radio-group
                        v-model="editedItem.enable_flag"
                        row
                        class="radiogroup"
                      >
                        <v-radio
                          label="Yes"
                          :value="true"
                          @change="changeActivestatus(true)"
                        ></v-radio>
                        <v-radio
                          label="No"
                          :value="false"
                          @change="changeActivestatus(false)"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <label class="radiolabel">Send Email*</label>
                      <v-radio-group
                        v-model="editedItem.email_enable_flag"
                        row
                        class="radiogroup"
                      >
                        <v-radio
                          label="Yes"
                          value="Y"
                          @change="changeActiveEmailstatus('Y')"
                        ></v-radio>
                        <v-radio
                          label="No"
                          value="N"
                          @change="changeActiveEmailstatus('N')"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                      <div id="container">
                        <v-card class="list-card">
                          <v-list>
                            <draggable v-model="todos">
                              <v-list-item v-for="todo in todos" :key="todo">
                                <v-list-item-content>
                                  <div
                                    draggable
                                    @dragstart="dragelement($event, todo)"
                                  >
                                    {{ todo[0] }}
                                  </div>
                                </v-list-item-content>
                              </v-list-item>
                            </draggable>
                          </v-list>
                        </v-card>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                      <v-row>
                        <v-textarea
                          @drop="onDropinsightcondition($event)"
                          @dragover.prevent
                          @dragenter.prevent
                          @change="
                            clearEvntinsightcondition(
                              editedItem.insight_condition
                            )
                          "
                          v-model="editedItem.insight_condition"
                          outlined
                          label="Insight Condition"
                          rows="6"
                          row-height="100"
                          required
                        ></v-textarea>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-row>
                        <v-textarea
                          @drop="onDropinsightstatement($event)"
                          @dragover.prevent
                          @dragenter.prevent
                          @change="
                            clearEvntinsightstatement(
                              editedItem.insight_statement
                            )
                          "
                          v-model="editedItem.insight_statement"
                          label="Insight statement"
                          outlined
                          rows="6"
                          row-height="10"
                          required
                        ></v-textarea>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-row>
                        <v-textarea
                          @drop="onDropdefaultstatement($event)"
                          @dragover.prevent
                          @dragenter.prevent
                          @change="
                            clearEvntDefaultstatement(
                              editedItem.default_statement
                            )
                          "
                          v-model="editedItem.default_statement"
                          label="Default statement"
                          outlined
                          rows="6"
                          row-height="10"
                          required
                        ></v-textarea>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions class="pb-5">
                <v-spacer></v-spacer>
                <v-btn outlined rounded color="error" @click="close">
                  <v-icon left>icon-cancel</v-icon>
                  Cancel
                </v-btn>
                <v-btn rounded color="primary" @click="save">
                  <v-icon left>icon-availability</v-icon>
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.status="{ item }">
        <v-switch
          color="indigo"
          @change="changeStatus(item, item.status)"
          false-value="false"
          true-value="true"
          v-model="item.enable_flag"
        ></v-switch>
      </template>
      <template v-slot:item.email_enable_flag="{ item }">
        <v-switch
          color="indigo"
          @change="changeStatus(item, item.status)"
          false-value="N"
          true-value="Y"
          v-model="item.email_enable_flag"
        ></v-switch>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          icon-action
        </v-icon>
      </template>
    </v-data-table>
    <div id="sucessAlert">
      <v-alert outlined type="success" text>
        Data Saved successfully.
      </v-alert>
    </div>
    <div id="errorAlert">
      <v-alert outlined type="warning" prominent border="left">
        Error while saving the data.
      </v-alert>
    </div>
  </v-container>
</template>
<script>
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";
import draggable from "vuedraggable";
import axios from "axios";
import VueJsonToCsv from "vue-json-to-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import router from "../router";
export default {
  components: {
    VueJsonToCsv,
    Breadcrumb,
    LoaderProgress,
    draggable,
  },
  data: () => ({
    showLoader: false,
    disableDevice: true,
    disableOperationalParameter: false,
    disablemachine: false,
    crumbs: ["Home", "Admin Menu", "Configuration for Machine Insights"],
    selectedItemsRules: [
      (v) =>
        (Array.isArray(v) && v.length > 0) ||
        "You must select at least one item",
    ],
    isEdit: false,
    machineItems: [],
    parameters: [],
    devices: [],
    dataDownload: [],
    headersData: [],
    operatorsData: [],
    todos: [],
    droppedItems: "",
    droppedStatement: "",
    defaultstatement: "",
    userItems: [],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    switch1: true,
    menu: false,
    dragOptions: {
      animation: 150,
    },
    items: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Admin Menu",
        disabled: true,
        href: "/",
      },
      {
        text: "Configuration for Alerts / Notifications",
        disabled: true,
      },
    ],
    search: "",
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "Machine",
        align: "start",
        sortable: true,
        value: "machine",
      },
      {
        text: "Operational Parameter",
        align: "start",
        sortable: true,
        value: "operationalparameter",
      },
      {
        text: "Insight_condition",
        align: "start",
        sortable: true,
        value: "operationalparameter",
      },
      {
        text: "Insight_statement",
        align: "start",
        sortable: true,
        value: "operationalparameter",
      },
      { text: "Action", value: "actions", sortable: false },
    ],
    oeemonitoring: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      machine_id: "",
      device_id: "",
      device_name: "",
      // parameter_id: "",
      insight_condition: "",
      insight_statement: "",
      insight_name: "",
      insight_type: "",
      email: "",
      user_id: "",
      enable_flag: true,
      email_enable_flag: "Y",
    },
    defaultItem: {
      // parameter_id: "",
      machine_id: "",
    },
    machine: ["Option 1", "Option 2", "Option 3", "Option 4", "Option 5"],
    operationalparameter: [
      "Option 1",
      "Option 2",
      "Option 3",
      "Option 4",
      "Option 5",
    ],
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add New" : "Edit Item";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.setGridData();
    this.setMachineData();
    this.getUsers();
  },
  methods: {
    selected(crumb) {
      if (crumb === "Home") {
        router.push(`/${sessionStorage.getItem("route_first_option")}`);
      }
      console.log(crumb);
    },
    addDoc() {
      this.isEdit = false;
      this.disablemachine = false;
      this.disableDevice = false;
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    createPDF() {
      let content = this.$refs["theDataTable"];
      console.log("pagination", this.pagination);
      let doc = new jsPDF("landscape");
      doc.text(14, 7.5, "Alerts/Notifications Configuration");
      doc.addImage(
        this.getImgUrl1(this.$config.image_inside_pdf),
        "png",
        this.$config.first_dimension_separate_again,
        this.$config.second_dimension_separate,
        this.$config.third_dimension_separate,
        this.$config.fourth_dimension_separate_again
      );
      let columnHeaders = [
        "Machine(s)",
        "Operational Parameter",
        "device_name",
        "Insight_name",
        "Insight_type",
        "Insight_condition",
        "Insight_statement",
        "email",
        "enable_flag",
        "email_enable_flag",
      ];
      let rows = [];
      content.items.forEach((data, index) => {
        if (
          index >= this.pagination.pageStart &&
          index < this.pagination.pageStop
        ) {
          let tempRow = [
            data.machine_name || "",
            data.parameter_name || "",
            data.device_name || "",
            data.insight_name || "",
            data.insight_type || "",
            data.insight_condition || "",
            data.insight_statement || "",
            data.email || "",
            data.enable_flag === "Y" ? "True" : "False",
            data.email_enable_flag === "Y" ? "On" : "Off",
          ];
          rows.push(tempRow);
        }
      });
      doc.setFontSize(9);
      doc.autoTable(columnHeaders, rows, { startY: 11.5 });
      let d = new Date();
      doc.save(
        `Alerts_Notifications_Config ${d.toISOString().slice(0, 10) +
          " " +
          d
            .toTimeString()
            .split("(")[0]
            .slice(0, -1)}.pdf`
      );
    },
    dragelement(evt, todo) {
      console.log("element check", evt, todo, todo[0], todo[1]);
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("todo", todo[0]);
    },
    onDropinsightcondition(evt) {
      console.log("abc", evt);
      const parameter_address = evt.dataTransfer.getData("todo");
      console.log("PA", parameter_address);
      this.droppedItems += "|*" + parameter_address + "*|";
      this.editedItem.insight_condition = this.droppedItems;
    },
    onDropinsightstatement(evt) {
      console.log("EPT", evt);
      const parameter_str = evt.dataTransfer.getData("todo");
      console.log("PS", parameter_str);
      this.droppedStatement += "|*" + parameter_str + "*|";
      this.editedItem.insight_statement = this.droppedStatement;
    },
    onDropdefaultstatement(evt) {
      const default_stat = evt.dataTransfer.getData("todo");
      this.defaultstatement += "|*" + default_stat + "*|";
      this.editedItem.default_statement = this.defaultstatement;
    },
    clearEvntinsightcondition(event) {
      this.droppedItems = event;
      console.log("eventevent-1", this.editedItem.insight_condition);
      console.log("abc", event);
    },
    clearEvntinsightstatement(event) {
      this.droppedStatement = event;
      console.log("clearevent-1", this.editedItem.insight_statement);
      console.log("which event", event);
    },
    clearEvntDefaultstatement(event) {
      this.defaultstatement = event;
    },
    changeActivestatus(item) {
      document.querySelector("#errorAlert").style.display = "none";
      console.log("checking enabled flag", item);
      this.editedItem.enable_flag = item;
    },
    changeActiveEmailstatus(item) {
      document.querySelector("#errorAlert").style.display = "none";
      console.log("checking SMS enabled flag", item);
      this.editedItem.email_enable_flag = item;
    },
    setMachineData() {
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getMachineNames`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          console.log("response--getMachineNames", response.data);
          let machineData = response.data.data;
          // machineData.sort((first_machine, second_machine) => {
          //   return this.compareObjects(
          //     first_machine,
          //     second_machine,
          //     "machine_name"
          //   );
          // });
          console.log("cehcking machine dayta=>", machineData);
          this.machineItems = machineData;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },

    getUsers() {
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getUsers`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.showLoader = true;
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          console.log("response--getUserNames", response.data);
          let userData = response.data.data;
          // userData.sort((first_machine, second_machine) => {
          //   return this.compareObjects(
          //     first_machine,
          //     second_machine,
          //     "machine_name"
          //   );
          // });
          console.log("cehcking user dayta=>", userData);
          this.userItems = userData;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },

    assigndevice(event) {
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getDevices?machine_id=${event}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          console.log("response--device names", response.data.data);
          this.devices = [];
          let devicesList = response.data.data;
          // devicesList.sort((first_operator, second_operator) => {
          //   return this.compareObjects(
          //     first_operator,
          //     second_operator,
          //     "device_name"
          //   );
          // });
          this.devices = devicesList;
          console.log("sons", this.devices);
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    getdeviceid(event) {
      console.log(
        "checking machine data and device data",
        event,
        this.editedItem.device_id
      );
      if (event === undefined || event === null) {
        event = this.editedItem.device_id;
      }
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getParameterlistData?machine_id=${this.editedItem.machine_id}&device_id=${event}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      // console.log("config",config)
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          console.log("response--names", response.data.data);
          let insightList = response.data.data;
          this.todos = insightList;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    assignparam(event) {
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getParametersData?machine_id=${event}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          this.parameters = [];
          let parametersList = response.data.data || [];
          // parametersList.sort((first_operator, second_operator) => {
          //   return this.compareObjects(
          //     first_operator,
          //     second_operator,
          //     "parameter_name"
          //   );
          // });
          this.parameters = parametersList;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    changeStatus(item, status) {
      console.log("checking item and status", item, status);
      let updated_user = sessionStorage.getItem("activeUser") || "";
      const req = {
        id: item.id,
        device_id: item.device_id,
        machine_id: item.machine_id,
        // device_type_id: item.device_id,
        // parameter_id: item.parameter_id,
        email_enable_flag: item.email_enable_flag,
        insight_name: item.insight_name,
        insight_condition: item.insight_condition,
        default_statement: item.default_statement,
        email: item.email,
        enable_flag: item.enable_flag,
        insight_statement: item.insight_statement,
        Insight_type: item.insight_type,
        updated_by: updated_user,
      };
      console.log("checking reqad item", req, item);
      this.showLoader = true;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/UpdateinsightsData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.setGridData();
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
          }
        });
    },
    setGridData: function() {
      this.headersData = [
        {
          text: "Machine",
          value: "machine_name",
          align: "start",
          sortable: true,
        },
        {
          text: "Insight_condition",
          value: "insight_condition",
          sortable: true,
        },
        {
          text: "Insight_statement",
          value: "insight_statement",
          sortable: true,
        },
        { text: "Actions", value: "actions", sortable: true },
      ];
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getInsightsData`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.showLoader = true;
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          console.log("checking initial data", response.data.data);
          this.operatorsData = response.data.data || [];
          let result = [];
          for (let i in response.data) result.push([i, response.data[i]]);
          console.log("checking result data=>", result[0][1]);
          this.dataDownload = result[0][1];
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else if (
            error.response &&
            error.response.status === 400 &&
            error.response.data.message ===
              "This Password is not allowed, Choose different password."
          ) {
            alert(error.response.data.message);
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    editItem(item) {
      console.log("ietm", item);
      this.assignparam(item.machine_id);
      this.assigndevice(item.machine_id);
      this.editedItem.machine_id = item.machine_id;
      this.editedItem.device_id = item.device_id;
      this.editedItem.user_id = item.user_id;
      console.log("tdi", this.devices.id);
      this.getdeviceid();
      this.disablemachine = true;
      this.disableDevice = true;
      this.isEdit = true;
      this.editedIndex = this.operatorsData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      console.log("edite", this.editItem);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.todos = [];
      (this.editedItem = ""),
        (this.droppedItems = ""),
        (this.droppedStatement = ""),
        (this.defaultstatement = ""),
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
    },
    save() {
      console.log("checking insertions", this.editedItem);
      if (!this.editedItem.machine_id) {
        alert("Please select Machine ");
        return;
      }
      // else if (!this.editedItem.parameter_id) {
      //   alert("Please select Operational Parameter");
      //   return;
      // }
      else if (!this.editedItem.device_id) {
        alert("Please select device");
        return;
      } else if (!this.editedItem.user_id) {
        alert("Please select user");
        return;
      } else if (!this.editedItem.insight_condition) {
        alert("Please Enter Insight Condition ");
        return;
      } else if (!this.editedItem.insight_statement) {
        alert("Please Enter Insight Statement");
        return;
      } else if (!this.editedItem.default_statement) {
        alert("Please Enter Default Statement");
        return;
      }
      let user = sessionStorage.getItem("activeUser") || "";
      const req = {
        id: this.editedItem.id,
        device_id: this.editedItem.device_id,
        machine_id: this.editedItem.machine_id,
        created_by: this.isEdit ? undefined : user,
        insight_condition: this.editedItem.insight_condition,
        insight_statement: this.editedItem.insight_statement,
        default_statement: this.editedItem.default_statement,
        enable_flag: this.editedItem.enable_flag,
        insight_name: this.editedItem.insight_name,
        email: this.editedItem.email,
        user_id: this.editedItem.user_id,
        email_enable_flag: this.editedItem.email_enable_flag,
        insight_type: this.editedItem.insight_type,
      };
      console.log("checking request data", req);
      let url = this.isEdit
        ? `${this.$config.backend_url}/UpdateinsightsData`
        : `${this.$config.backend_url}/insightsDataEntry`;
      this.showLoader = true;
      let config = {
        method: "post",
        url: url,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.setGridData();
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
          }
        });
      this.close();
    },
  },
};
</script>
<style scoped>
.todo {
  min-width: 150px;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 20px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
}
.list-card {
  height: 200px;
  overflow-y: auto;
}
#container {
  max-width: 250px;
  padding: 5px;
  border-radius: 5px;
  border-color: red;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
}
#sucessAlert {
  display: none;
}
#errorAlert {
  display: none;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
